var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("["),_c('a',{attrs:{"href":"https://剑网3.com"}},[_vm._v("剑网3.com")]),_vm._v("]正在为您导航……")])
}]

export { render, staticRenderFns }